<template>
  <div class="d-inline-block">
    <v-btn-toggle
      v-model="selectedFrequencyIndex"
      tile
      mandatory
      v-bind="$attrs"
      color="primary"
      :class="{ 'flex-column': $vuetify.breakpoint.smAndDown }"
      @change="notify"
    >
      <v-btn v-for="option in options" :key="option.value" class="option">
        <div v-if="option.discount" class="discount pa-1 caption">save {{ option.discount }}%</div>
        {{ option.displayName }}
      </v-btn>
    </v-btn-toggle>
    <div class="text-center caption">Billed {{ selectedFrequency.frequency }}</div>
  </div>
</template>

<script>
export default {
  data: () => ({
    selectedFrequencyIndex: 0,
    options: [
      {
        value: 'monthly',
        displayName: 'Monthly',
        discount: 0,
        months: 1,
        frequency: 'once a month'
      },
      {
        value: 'quaterly',
        displayName: 'Quarterly',
        discount: 10,
        months: 3,
        frequency: 'once every 3 months'
      },
      {
        value: 'semi-anual',
        displayName: 'Semi-Annually',
        discount: 15,
        months: 6,
        frequency: 'once every 6 months'
      }
    ]
  }),

  computed: {
    selectedFrequency() {
      return this.options[this.selectedFrequencyIndex]
    }
  },

  mounted() {
    this.notify()
  },

  methods: {
    notify() {
      this.$emit('input', this.selectedFrequency)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles.scss';
@import '~vuetify/src/styles/styles.sass';

.discount {
  top: -5px;
  right: 0px;
  position: absolute;
  background: $secondary;
  color: black;
  z-index: 1;
}

.option {
  width: 80vw;
  border: 1px solid black !important;
  margin-bottom: 1px;
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .discount {
    top: -30px;
    right: auto;
  }

  .option {
    width: 150px;
  }
}
</style>
